<template>
    <Modal class="tiw__step__enterImei">
        <template #header>
            <p class="tiw__h2">
                {{
                    useTranslate(
                        ChooseDeviceStore.isImei
                            ? "tiw__enterImei__title"
                            : "tiw__enterImei__title-serial",
                    )
                }}
            </p>
        </template>

        <div>
            <HandedDevice
                :device-chain="ChooseDeviceStore.deviceChain"
                :device-state="HowYouRateDeviceStore.rate"
                :device-preview="ChooseDeviceStore.deviceImagePreview"
                :device-grade="null"
                :device-no-grade="false"
                :device-terminated="false"
                :on-edit="onEditHandler"
            />
            <form name="enterImeiForm">
                <!-- Поле "IMEI" -->
                <Field :is-error="!EnterImeiValidation.status || !EnterSerialValidation.status">
                    <template #hintTop>
                        <div class="tiw__step__enterImei__howFindImei">
                            <span v-if="ChooseDeviceStore.isImei">
                                {{ useTranslate("tiw__enterImei__imei") }}
                            </span>
                            <span v-else>
                                {{ useTranslate("tiw__enterImei__serial") }}
                            </span>
                            <Button
                                v-if="ChooseDeviceStore.isImei && !howFindImeiBlock"
                                color="link"
                                variant="link"
                                type="button"
                                class="tiw_fs-12"
                                @click="showInfoAboutImei"
                            >
                                <span>
                                    {{ useTranslate("tiw__enterImei__howFindImei") }}
                                </span>
                            </Button>
                        </div>
                    </template>
                    <template #body>
                        <Input
                            v-if="ChooseDeviceStore.isImei"
                            v-model="ChooseDeviceStore.field_imei.value"
                            type="text"
                            :placeholder="useTranslate('tiw__enterImei__imei')"
                            name="imei"
                            maxlength="15"
                            inputmode="numeric"
                            :disabled="loadingToNext"
                        />
                        <Input
                            v-else
                            v-model="ChooseDeviceStore.field_serial.value"
                            type="text"
                            :placeholder="useTranslate('tiw__enterImei__serial')"
                            name="serial"
                            maxlength="25"
                            minlength="5"
                            :disabled="loadingToNext"
                        />
                    </template>
                    <template
                        v-if="!EnterImeiValidation.status || !EnterSerialValidation.status"
                        #hintBottom
                    >
                        <span v-if="ChooseDeviceStore.isImei">
                            {{ EnterImeiValidation.message }}
                        </span>
                        <span v-else>
                            {{ EnterSerialValidation.message }}
                        </span>
                    </template>
                </Field>

                <template v-if="loadingToNext">
                    <div class="tiw__step__enterImei__status">
                        <CheckIcon variant="circled" />
                        <span>
                            {{
                                useTranslate(
                                    ChooseDeviceStore.isImei
                                        ? "tiw__enterImei__status"
                                        : "tiw__enterImei__status-serial",
                                )
                            }}
                        </span>
                    </div>
                </template>

                <template v-if="imeiRetryEnter">
                    <div class="tiw__step__enterImei__warn">
                        <div
                            v-if="errorMessage.modelName"
                            class="tiw__step__enterImei__warn__model"
                        >
                            <div class="tiw__step__enterImei__warn__model__title">
                                {{ useTranslate("tiw__enterImei__yourModel") }}
                            </div>
                            <span class="tiw__step__enterImei__warn__model__phone">
                                {{ errorMessage.modelName }}
                            </span>
                        </div>
                        {{ errorMessage.error }}
                    </div>
                    <div class="tiw_group tiw_group-sb" :class="{ tiw_mb16: foundSignedContract }">
                        <Button
                            color="link"
                            variant="link"
                            type="button"
                            class="tiw_fs-12"
                            @click="showInfoAboutImei"
                        >
                            <span>
                                {{ useTranslate("tiw__enterImei__howFindImei") }}
                            </span>
                        </Button>
                        <Button
                            type="button"
                            class="tiw__step__enterImei__btn-close"
                            @click="clickToNext"
                        >
                            <span>{{ useTranslate("tiw__continue") }}</span>
                        </Button>
                    </div>
                </template>
                <template v-else-if="imeiIsNotValid">
                    <div class="tiw__step__enterImei__warn">
                        <div
                            v-if="errorMessage.modelName"
                            class="tiw__step__enterImei__warn__model"
                        >
                            <div class="tiw__step__enterImei__warn__model__title">
                                {{ useTranslate("tiw__enterImei__yourModel") }}
                            </div>
                            <span class="tiw__step__enterImei__warn__model__phone">
                                {{ errorMessage.modelName }}
                            </span>
                        </div>
                        {{ errorMessage.error }}
                    </div>
                    <div class="tiw_group tiw_group-sb" :class="{ tiw_mb16: foundSignedContract }">
                        <Button
                            color="link"
                            variant="link"
                            type="button"
                            class="tiw_fs-12"
                            @click="showInfoAboutImei"
                        >
                            <span>
                                {{ useTranslate("tiw__enterImei__howFindImei") }}
                            </span>
                        </Button>
                        <Button
                            v-if="errorMessage.modelName || imeiRetryEnter"
                            type="button"
                            class="tiw__step__enterImei__btn-close"
                            @click="onEditHandler"
                        >
                            <span>{{ useTranslate("tiw__continue") }}</span>
                        </Button>
                        <Button
                            v-else
                            type="button"
                            class="tiw__step__enterImei__btn-close"
                            @click="clickToClose"
                        >
                            <span>{{ useTranslate("tiw__close") }}</span>
                        </Button>
                    </div>
                </template>
                <template v-else-if="deviceTerminated">
                    <div class="tiw__step__enterImei__warn">
                        {{ useTranslate("tiw__step__enterImei__warn__deviceTerminated") }}
                    </div>
                    <Button
                        type="button"
                        class="tiw__step__enterImei__btn-close"
                        @click="clickToClose"
                    >
                        <span>{{ useTranslate("tiw__close") }}</span>
                    </Button>
                </template>
                <template v-else>
                    <div class="tiw_group tiw_group-sb" :class="{ tiw_mb16: foundSignedContract }">
                        <BackButton @click="onBack" />
                        <Button
                            type="button"
                            class="tiw__step__enterImei__btn-next"
                            :disabled="loadingToNext || foundSignedContract || isDisabled"
                            :loading="loadingToNext"
                            @click="clickToNext"
                        >
                            <span>
                                {{ useTranslate("tiw__continue") }}
                            </span>
                        </Button>
                    </div>
                </template>

                <template v-if="foundSignedContract">
                    <div class="tiw__step__enterImei__foundSignedContract tiw_mb8">
                        <div class="tiw__step__enterImei__foundSignedContract__title">
                            {{ useTranslate("tiw__enterImei__imei_foundSignedContract_title") }}
                        </div>
                        <div
                            class="tiw__step__enterImei__foundSignedContract__text"
                            v-html="foundSignedContractText"
                        ></div>
                    </div>
                    <div class="tiw__step__enterImei__btn">
                        <Button
                            type="button"
                            color="light"
                            class="tiw__step__enterImei__btn-re-evaluate"
                            @click="onClickReEvaluate"
                        >
                            <span>{{
                                useTranslate("tiw__enterImei__imei_foundSignedContract_re_evaluate")
                            }}</span>
                        </Button>

                        <Button
                            type="button"
                            class="tiw__step__enterImei__btn-apply-evaluate"
                            @click="onClickApplyEvaluate"
                        >
                            <span>{{
                                useTranslate(
                                    "tiw__enterImei__imei_foundSignedContract_apply_evaluate",
                                )
                            }}</span>
                        </Button>
                    </div>
                </template>

                <template v-if="ChooseDeviceStore.isImei">
                    <div v-if="howFindImeiBlock" class="tiw__step__enterImei__info">
                        <h3 class="tiw__title">
                            {{ useTranslate("tiw__enterImei__howFindImei") }}
                        </h3>
                        <ul class="tiw__ul tiw__ul_disc tiw_fs-14">
                            <li v-html="useTranslate('tiw__enterImei__howFindImei_step1')" />
                            <li>
                                {{ useTranslate("tiw__enterImei__howFindImei_step2") }}
                            </li>
                        </ul>
                        <div class="tiw__step__enterImei__info__images">
                            <figure class="tiw_tc">
                                <img
                                    width="100%"
                                    :src="`${pathToImages}/img/iphone_imei_1.webp`"
                                    alt="iPhone dial *#06#"
                                />
                            </figure>
                            <figure class="tiw_tc">
                                <img
                                    width="100%"
                                    :src="`${pathToImages}/img/iphone_imei_2.webp`"
                                    alt="iPhone dial *#06#"
                                />
                            </figure>
                        </div>
                    </div>
                    <div class="tiw__step__enterImei__info__openHide">
                        <Button
                            v-if="howFindImeiBlock"
                            color="link"
                            variant="link"
                            type="button"
                            class="tiw_fs-12"
                            @click="showInfoAboutImei"
                        >
                            <span>{{ useTranslate("tiw__hide") }}</span>
                        </Button>
                    </div>
                </template>
            </form>
        </div>
    </Modal>
</template>

<script lang="ts">
export default {
    name: "EnterImei",
};
</script>

<script setup lang="ts">
/**
 * * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [EnterImei]
 * Модальное окно / экран "Введите IMEI"
 */

// Hooks
import { ref, computed, watch } from "vue";

import HandedDevice from "@/components/handedDevice/handedDevice.vue";
// Components
import Modal from "@/components/modal/modal.vue";
import { useBugTracker, BugTrackerSection } from "@/helpers/bugTracker";
import it4CheckPhotoSetStatus from "@/hooks/requests/it4CheckPhotoSetStatus/it4CheckPhotoSetStatus";
import it4GetIMEIStatus from "@/hooks/requests/it4GetIMEIStatus/it4GetIMEIStatus";
import it4GetLoadPhotoFields from "@/hooks/requests/it4GetLoadPhotoFields/it4GetLoadPhotoFields";
import it4UpdateIMEI from "@/hooks/requests/it4UpdateIMEI/it4UpdateIMEI";
// import it4CheckContractSign from "@/hooks/requests/it4CheckContractSign/it4CheckContractSign";
import {
    useAnalyticsEventAddPhoto,
    useAnalyticsEventTiModel,
} from "@/hooks/useAnalytics/useAnalytics";
import useQRPath from "@/hooks/useQRPath/useQRPath";
import useStoreResetter from "@/hooks/useStoreResetter/useStoreResetter";
import useTradeInCalculation from "@/hooks/useTradeInCalculation/useTradeInCalculation";
import useTranslate from "@/hooks/useTranslate/useTranslate";
import useValidate from "@/hooks/useValidate";
import { useChooseDeviceStore } from "@/stores/chooseDevice/chooseDevice";
import { useDownloadPhotosStore } from "@/stores/downloadPhotos/downloadPhotos";
import { useHowYouRateDeviceStore } from "@/stores/howYouRateDevice/howYouRateDevice";
// Store
import { useTIWStore } from "@/stores/tiw/tiw";
import Button from "@/ui/button/button.vue";
import Field from "@/ui/field/field.vue";
// Icon
import CheckIcon from "@/ui/icons/check.vue";
import Input from "@/ui/input/input.vue";
import { deviceGradeIsEquals } from "~/tiw/helpers/deviceGrade";
import BackButton from "~/tiw/ui/button/backButton/backButton.vue";
// import { useSuccessfulEvaluationStore } from "@/stores/successfulEvaluation/successfulEvaluation";

const TIWStore = useTIWStore();
const ChooseDeviceStore = useChooseDeviceStore();
const HowYouRateDeviceStore = useHowYouRateDeviceStore();
const DownloadPhotosStore = useDownloadPhotosStore();
// const SuccessfulEvaluationStore = useSuccessfulEvaluationStore();

const pathToImages = import.meta.env.VITE_APP_URL;

const onEditHandler = () => {
    HowYouRateDeviceStore.restoreToDefault();
    ChooseDeviceStore.restoreToDefault();
    TIWStore.switchStep("chooseDevice");
    useAnalyticsEventTiModel();
};

const EnterImeiValidation = computed(() => {
    if (!ChooseDeviceStore.field_imei.value.length) {
        return {
            status: true,
            message: "ok",
        };
    }
    const validate = useValidate({
        target: "imei",
        value: ChooseDeviceStore.field_imei.value,
    });
    return validate;
});

const EnterSerialValidation = computed(() => {
    if (!ChooseDeviceStore.field_serial.value.length) {
        return {
            status: true,
            message: "ok",
        };
    }
    const validate = useValidate({
        target: "serial",
        value: ChooseDeviceStore.field_serial.value,
    });
    return validate;
});

const isDisabled = computed(() => {
    if (ChooseDeviceStore.isImei) {
        return !EnterImeiValidation.value.status || !ChooseDeviceStore.field_imei.value.length;
    } else {
        return !EnterSerialValidation.value.status || !ChooseDeviceStore.field_serial.value.length;
    }
});

const howFindImeiBlock = ref<boolean>(true);
const imeiIsNotValid = ref<boolean>(false);
const imeiRetryEnter = ref<boolean>(false);
const deviceTerminated = ref<boolean>(false);
const errorMessage = ref<{ error: string; modelName?: string }>({
    error: "",
    modelName: "",
});
const imeiDataId = ref<string>("");
const previousEvaluationResultPrice = ref<string>("");
const updateInfoDeviceIdForReuse = ref<string>("");
const foundSignedContract = computed<boolean>((): boolean => {
    return updateInfoDeviceIdForReuse.value.length > 0;
});
const foundSignedContractText = computed<string>((): string => {
    const price: string =
        typeof HowYouRateDeviceStore.calculatedDeviceData.panelTradeInSale === "string"
            ? HowYouRateDeviceStore.calculatedDeviceData.panelTradeInSale
            : HowYouRateDeviceStore.calculatedDeviceData.panelTradeInSale.tradeInSale;

    const currency: string = HowYouRateDeviceStore.registeringDeviceData.currency;

    return useTranslate("tiw__enterImei__imei_foundSignedContract_text")
        .replace("[[PRICE]]", previousEvaluationResultPrice.value || price)
        .replace("[[CURRENCY]]", currency);
});

const showInfoAboutImei = () => (howFindImeiBlock.value = !howFindImeiBlock.value);

const loadingToNext = ref<boolean>(false);

watch(ChooseDeviceStore.field_imei, () => {
    deviceTerminated.value = false;
    updateInfoDeviceIdForReuse.value = "";

    if (ChooseDeviceStore.field_imei.value && EnterImeiValidation.value.status) {
        imeiIsNotValid.value = false;
    }
});

const onBack = () => {
    TIWStore.switchStep("howYouRateDevice");
};

const clickToClose = async () => {
    TIWStore.closeWidget();
    useStoreResetter();
    TIWStore.INJECTED_TIW.current_api.onDrop();
};

const interval = ref();

const getImeiExecuter = async (id: string) => {
    try {
        const imeiData = await it4GetIMEIStatus({
            token: TIWStore.WIDGET_DATA.token, // "d7bd115c-e845-4381-8f11-8044cbc11dfe",
            id, // "c6d7acf4-4657-4b79-b7c2-5e941fc3760d"
        });

        if (imeiData.status === "IN_PROGRESS") return;

        if (!imeiData.result || !imeiData.result?.imeiValidation) {
            useBugTracker(
                "EnterImei - it4GetIMEIStatus (response error)",
                BugTrackerSection.ERROR,
                {
                    response: imeiData,
                },
            );

            return;
        }

        // check updateInfo

        // hack
        imeiData.result.imeiValidation.valid = true;

        if (imeiData.result.imeiValidation.valid || imeiData.result.imeiValidation.unavailable) {
            await useQRPath();

            try {
                // Для экрана "Загрузите фото сдаваемого устройства" - загрузить поля для загрузки фото
                const loadPhotoFieldsData = await it4GetLoadPhotoFields({
                    deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId,
                    token: TIWStore.WIDGET_DATA.token,
                    lang: TIWStore.standardizedLocale,
                });

                DownloadPhotosStore.fieldsLineData = loadPhotoFieldsData;
            } catch (e) {
                useBugTracker("EnterImei - it4GetLoadPhotoFields", BugTrackerSection.ERROR, {
                    exception: e.message,
                    request: {
                        deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId,
                        token: TIWStore.WIDGET_DATA.token,
                        lang: TIWStore.standardizedLocale,
                    },
                });
            }

            loadingToNext.value = false;

            clearInterval(interval.value);

            ChooseDeviceStore.field_imei.savedValue = ChooseDeviceStore.field_imei.value;

            if (HowYouRateDeviceStore.skipPhotoGradingStep) {
                TIWStore.switchStep("evaluationResult");
            } else {
                TIWStore.switchStep("downloadPhotos");
            }

            useAnalyticsEventAddPhoto();
        } else {
            /**
                "1-й экран 'К сожалению устройство не принимается'"
                    "unavailable": !true,
                    "valid": false,
                    "found": false,

                "2-й экран 'Проверьте правильность IMEI'"
                    "unavailable": !true,
                    "modelName": null || '' [1 условие]

                "3-й экран 'Пожалуйста перепройдите проверку'"
                    "unavailable": !true,
                    "valid": false,
                    "found": true,
            */

            if (!imeiData.result.imeiValidation.modelName) {
                console.log("UNCORRECT");
                errorMessage.value = {
                    error: useTranslate("tiw__enterImei__imei_uncorrect"),
                };
            } else {
                if (
                    !imeiData.result.imeiValidation.valid &&
                    !imeiData.result.imeiValidation.found
                ) {
                    console.log("NOT ACCEPTED");
                    errorMessage.value = {
                        error: useTranslate("tiw__enterImei__imei_notAccepted"),
                    };
                }

                if (!imeiData.result.imeiValidation.valid && imeiData.result.imeiValidation.found) {
                    console.log("RE EVALUATE");
                    errorMessage.value = {
                        error: useTranslate("tiw__enterImei__imei_reEvaluate"),
                        modelName: imeiData.result.imeiValidation.modelName,
                    };
                }
            }
            imeiIsNotValid.value = true;
            loadingToNext.value = false;
            clearInterval(interval.value);
        }
    } catch (e) {
        useBugTracker("EnterImei - it4GetIMEIStatus", BugTrackerSection.ERROR, {
            exception: e.message,
            request: {
                token: TIWStore.WIDGET_DATA.token,
                id: id,
            },
        });
    }
};

const runIntervalImeiExecuter = () => {
    let intervalCount: number = 0;
    const MAX_INTERVAL_COUNT: number = 5;

    interval.value = setInterval(async () => {
        intervalCount++;

        await getImeiExecuter(imeiDataId.value);

        if (intervalCount >= MAX_INTERVAL_COUNT) {
            clearInterval(interval.value);
            interval.value = null;

            errorMessage.value = {
                error: useTranslate("tiw__enterImei__imei_uncorrect"),
            };

            imeiRetryEnter.value = true;
            loadingToNext.value = false;

            return;
        }
    }, 5000);
};

const onClickReEvaluate = () => {
    updateInfoDeviceIdForReuse.value = "";
    loadingToNext.value = true;
    imeiRetryEnter.value = false;
    runIntervalImeiExecuter();
};

const onClickApplyEvaluate = async () => {
    HowYouRateDeviceStore.registeringDeviceData.deviceId = updateInfoDeviceIdForReuse.value;

    TIWStore.switchStep("successfulEvaluation");
};

const clickToNext = async () => {
    const currentValue = computed(() =>
        ChooseDeviceStore.isImei
            ? ChooseDeviceStore.field_imei.value
            : ChooseDeviceStore.field_serial.value,
    );
    const savedValue = computed(() =>
        ChooseDeviceStore.isImei
            ? ChooseDeviceStore.field_imei.savedValue
            : ChooseDeviceStore.field_serial.savedValue,
    );

    // Это типо если был шаг "назад" т.к. имей уже был
    // успешно проверен
    if (currentValue.value === savedValue.value) {
        if (HowYouRateDeviceStore.skipPhotoGradingStep) {
            TIWStore.switchStep("successfulEvaluation");
        } else {
            TIWStore.switchStep("downloadPhotos");
        }
        useAnalyticsEventAddPhoto();
        return;
    }

    loadingToNext.value = true;
    imeiRetryEnter.value = false;

    try {
        const imeiData = await it4UpdateIMEI({
            article: TIWStore.INJECTED_GOOD?.article ?? "", // артикул устройства со страницы партнера
            token: TIWStore.WIDGET_DATA.token, // "d7bd115c-e845-4381-8f11-8044cbc11dfe",
            imei: currentValue.value, // IMEI устройства
            deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId, // deviceID сдаваемого устройства
        });

        imeiDataId.value = imeiData.id;

        const updateInfo_Status: string = imeiData.result.updateInfo?.status || "";
        const updateInfo_DeviceId: string = imeiData.result.updateInfo?.deviceIdForReuse || "";
        const updateInfo_PhotosetId: string = imeiData.result.updateInfo?.photosetId || "";

        if (updateInfo_DeviceId && updateInfo_PhotosetId) {
            if (updateInfo_Status === "found_order") {
                // заказ уже есть - устройство не принимаем
                deviceTerminated.value = true;
                return;
            }

            if (updateInfo_Status === "found_but_too_late") {
                runIntervalImeiExecuter();
                return;
            }

            try {
                // есть предыдущая оценка с подписанным договором
                // значит сохраняем предыдущий deviceId из deviceIdForReuse
                // с предварительным запросом статуса фотосета (там есть результат оценки)
                const photoSetStatus = await it4CheckPhotoSetStatus({
                    deviceId: updateInfo_DeviceId,
                    photosetId: updateInfo_PhotosetId,
                    token: TIWStore.WIDGET_DATA.token,
                    lang: TIWStore.standardizedLocale,
                });

                const isSameDevice =
                    ChooseDeviceStore.field_imei.value === photoSetStatus.deviceImei &&
                    ChooseDeviceStore.field_model.value.name === photoSetStatus.model &&
                    ChooseDeviceStore.field_color.value.color === photoSetStatus.color &&
                    ChooseDeviceStore.field_storage.value.storage === photoSetStatus.storage &&
                    deviceGradeIsEquals(HowYouRateDeviceStore.grade, photoSetStatus.grade);

                if (isSameDevice) {
                    previousEvaluationResultPrice.value = String(photoSetStatus.price);
                    HowYouRateDeviceStore.grade = photoSetStatus.grade;
                    HowYouRateDeviceStore.rate = photoSetStatus.gradeName;
                    useTradeInCalculation({
                        tradeInPrice: previousEvaluationResultPrice.value,
                    });

                    updateInfoDeviceIdForReuse.value = updateInfo_DeviceId;
                } else {
                    onClickReEvaluate();
                    return;
                }
            } catch (e) {
                useBugTracker("EnterImei - it4CheckPhotoSetStatus", BugTrackerSection.ERROR, {
                    exception: e.message,
                    request: {
                        deviceId: updateInfo_DeviceId,
                        photosetId: updateInfo_PhotosetId,
                        token: TIWStore.WIDGET_DATA.token,
                        lang: TIWStore.standardizedLocale,
                    },
                });
            }

            loadingToNext.value = false;
        } else {
            runIntervalImeiExecuter();
        }
    } catch (e) {
        useBugTracker("EnterImei - it4UpdateIMEI", BugTrackerSection.ERROR, {
            exception: e.message,
            request: {
                article: TIWStore.INJECTED_GOOD?.article ?? "",
                token: TIWStore.WIDGET_DATA.token,
                imei: ChooseDeviceStore.field_imei.value,
                deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId,
            },
        });

        loadingToNext.value = false;
    }
};
</script>

<style lang="scss" src="./enterImei.scss"></style>
